import { render, staticRenderFns } from "./Jjfa.vue?vue&type=template&id=187ceccf&scoped=true"
import script from "./Jjfa.vue?vue&type=script&lang=js"
export * from "./Jjfa.vue?vue&type=script&lang=js"
import style0 from "./Jjfa.vue?vue&type=style&index=0&id=187ceccf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ceccf",
  null
  
)

export default component.exports